import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
import { CountdownTimer } from './ui/CountdownTimer';
const checkoutUrl = 'https://basketball-ready-system-365.impultienda.ar/checkout';
export function SpecialOffer() {
  return <section id="offer" className="relative overflow-hidden bg-navy-900 py-12 md:py-24" data-id="element-211">
      <div className="pointer-events-none absolute inset-0 bg-stadium-glow opacity-80" data-id="element-212" />

      <div className="container relative z-10 mx-auto px-4" data-id="element-213">
        <div className="max-w-4xl mx-auto" data-id="element-214">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-8 text-center md:mb-12" data-id="element-215">
            <div className="mb-6 inline-block rounded-full bg-red-600 px-4 py-1 font-oswald text-sm uppercase tracking-widest text-white animate-pulse" data-id="element-216">
              Launch Offer
            </div>
            <h2 className="mb-3 font-anton text-3xl uppercase tracking-normal text-white md:mb-4 md:text-6xl md:tracking-wide" data-id="element-217">
              SPECIAL OFFER
            </h2>
            <h3 className="font-oswald text-lg uppercase tracking-wide text-gold-500 md:text-3xl md:tracking-widest" data-id="element-218">
              THE COMPLETE 6-VOLUME SYSTEM
            </h3>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative rounded-2xl border-2 border-gold-500/50 bg-navy-950 p-4 pt-7 shadow-[0_0_50px_rgba(239,43,45,0.18)] sm:p-6 sm:pt-9 md:p-12 md:pt-12" data-id="element-219">
            <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-gold-500/50 bg-navy-950 px-4 py-1 md:px-6 md:py-2" data-id="element-220">
              <span className="font-anton text-base tracking-wide text-gold-500 md:text-xl md:tracking-wider" data-id="element-221">
                76% OFF
              </span>
            </div>

            <div className="mb-6 md:mb-10" data-id="element-222">
              <img src="https://cdn.magicpatterns.com/uploads/vF1P8TNmaRQc6eH9i9F9uw/ChatGPT_Image_19_jun_2026,_01_16_23.webp" alt="Basketball Ready: System 365 complete coaching system" loading="lazy" decoding="async" className="mx-auto h-auto w-full max-w-2xl rounded-xl shadow-2xl" data-id="element-223" />
            </div>

            <div className="mb-6 text-center md:mb-10" data-id="element-224">
              <div className="mb-1 font-oswald text-base text-gray-400 line-through md:mb-2 md:text-xl" data-id="element-225">
                Regular Price: USD 97
              </div>
              <div className="mb-1 font-oswald text-lg uppercase tracking-wide text-gold-500 md:mb-2 md:text-2xl md:tracking-widest" data-id="element-226">
                Today Only:
              </div>
              <div className="mb-3 whitespace-nowrap font-anton text-[3rem] leading-none tracking-normal text-white drop-shadow-lg sm:text-6xl md:mb-4 md:text-8xl md:tracking-wider" data-id="element-227">
                USD 27
              </div>
              <p className="text-sm text-gray-400" data-id="element-228">
                Pay securely in your local currency.
              </p>
            </div>

            <div className="mb-6 rounded-xl border border-navy-700 bg-navy-900 p-4 md:mb-10 md:p-6" data-id="element-229">
              <div className="mb-4 text-center md:mb-6" data-id="element-230">
                <span className="mb-3 flex flex-wrap items-center justify-center gap-2 text-center text-base font-bold text-red-400 sm:text-xl md:mb-4" data-id="element-231">
                  <span className="animate-pulse" data-id="element-232">🔥</span>
                  LAST CHANCE — LIMITED TIME
                </span>
                <p className="text-sm leading-5 text-gray-300 md:text-base" data-id="element-233">
                  Basketball Ready: System 365 is available at launch pricing
                  for coaches who take action today. When this countdown
                  expires, the price returns to USD 97.
                </p>
              </div>
              <CountdownTimer data-id="element-234" />
            </div>

            <div className="flex flex-col items-center gap-4 md:gap-6" data-id="element-235">
              <Button size="xl" fullWidth className="max-w-2xl flex flex-col items-center" onClick={() => {
              ;
              (window as any).fbq?.('track', 'InitiateCheckout', {
                value: 27,
                currency: 'USD'
              });
              window.location.href = checkoutUrl;
            }} data-id="element-236">
                <span data-id="element-237">YES, I WANT BASKETBALL READY →</span>
                <span className="mt-1 font-inter text-xs font-normal normal-case opacity-90" data-id="element-238">
                  6 Volumes + 5 Bonuses — Delivered Immediately
                </span>
              </Button>

              <div className="flex flex-col items-center gap-3 px-1 text-center" data-id="element-239">
                <div className="flex flex-wrap items-center justify-center gap-1" data-id="element-240">
                  {[...Array(5)].map((_, index) => <Star key={index} className="h-5 w-5 fill-gold-500 text-gold-500" data-id="element-241" />)}
                  <span className="w-full font-oswald text-base text-gray-200 sm:ml-2 sm:w-auto sm:text-lg" data-id="element-242">
                    4.9/5 — Verified Reviews
                  </span>
                </div>
                <div className="mt-1 flex items-center justify-center gap-2 text-center text-sm font-medium text-gray-400" data-id="element-243">
                  <ShieldCheck className="h-4 w-4 flex-shrink-0 text-green-500" data-id="element-244" />
                  <span data-id="element-245">7-Day Money Back Guarantee — Zero Risk</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}